import { useEffect, useState } from "react";

import { FlagIcon } from "react-flag-kit";
import Slide from "@material-ui/core/Slide";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import Select from "@material-ui/core/Select";
import { useTranslation } from "react-i18next";
import { DialogTitle } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import { Navigate, Link, useParams } from "react-router-dom";
import DialogContentText from "@material-ui/core/DialogContentText";

import {
  getLangAll,
  deletePrices,
  postPlanPrices,
  deletePlanPrices,
  getPlansAndPrices,
  getCountriesPrices,
} from "../../store/middleware";
import MenuItem from "@material-ui/core/MenuItem";
import Header from "../../components/Header/NewHeader";
import SideMenu from "../../components/SideMenu/SideMenu";
import Engrenagem from "../../assets/images/icons/icon_planspricing_header.svg";

import { Prices } from "./styles";
import { SCButtonAddInput } from "../../components/Buttons/styles";

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

function PlansAndPrices() {
  let { id } = useParams();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { allLingos } = useSelector((state) => state.genericReducer);

  const [open, setOpen] = useState(false);
  const [prices, setPrices] = useState([]);
  const [trial, setTrial] = useState(false);
  const [active, setActive] = useState(false);
  const [provider, setProvider] = useState("");
  const [dialogMsg, setDialogMsg] = useState("");
  const [countries, setCountries] = useState([]);
  const [isDelete, setIsDelete] = useState(false);
  const [redirect, setRedirect] = useState(false);
  const [nameFrench, setNameFrench] = useState("");
  const [activeWeb, setActiveWeb] = useState(false);
  const [unlimited, setUnlimited] = useState(false);
  const [nameSpanish, setNameSpanish] = useState("");
  const [nameEnglish, setNameEnglish] = useState("");
  const [dialogTitle, setDialogTitle] = useState("");
  const [paymentLink, setPaymentLink] = useState("");
  const [multiLingo, setMultiLingo] = useState(false);
  const [totalClasses, setTotalClasses] = useState("");
  const [planLanguages, setPlanLanguages] = useState([]);
  const [namePortuguese, setNamePortuguese] = useState("");
  const [descriptionFrench, setDescriptionFrench] = useState("");
  const [descriptionEnglish, setDescriptionEnglish] = useState("");
  const [descriptionSpanish, setDescriptionSpanish] = useState("");
  const [descriptionPortuguese, setDescriptionPortuguese] = useState("");
  const [pricesPartners, setPricesPartners] = useState([
    {
      baseValue: 0,
      discount: 0,
      value: 0,
      utmCpn: "",
      priceCountryId: 0,
      bestSeller: false,
      currency: "",
      exclusiveFor: "partner",
    },
  ]);
  const [pricesAffiliate, setPricesAffiliate] = useState([
    {
      baseValue: 0,
      discount: 0,
      value: 0,
      utmCpn: "",
      priceCountryId: 0,
      bestSeller: false,
      currency: "",
      exclusiveFor: "affiliate",
    },
  ]);

  console.log(countries);

  const loadInfos = () => {
    dispatch(getCountriesPrices()).then((res) => setCountries(res));
    dispatch(getLangAll());

    let countryId = id;

    if (countryId !== undefined) {
      dispatch(getPlansAndPrices(countryId))
        .then((res) => {
          let pricesMaped = [];
          let pricesPartners = [];
          let pricesAffiliate = [];

          if (res && res.length === 0) return false;

          const arrayPrices = res[0]?.plan?.prices;

          if (res[0]?.plan && arrayPrices) {
            if (arrayPrices.find((item) => item.exclusiveFor === null)) {
              arrayPrices.map((itemPrice) => {
                pricesMaped.push({
                  id: itemPrice.id,
                  value: itemPrice.value,
                  utmCpn: itemPrice.utmCpn,
                  discount: itemPrice.discount,
                  exclusiveFor: "website_stripe",
                  baseValue: itemPrice.baseValue,
                  bestSeller: itemPrice.bestSeller,
                  priceCountryId: itemPrice.priceCountryId,
                  currency: itemPrice.priceCountry.standardCurrency,
                });
              });

              let pricesMapedPartners = pricesMaped.map((item) => ({ ...item, exclusiveFor: "partner" }));
              let pricesMapedAffiliate = pricesMaped.map((item) => ({ ...item, exclusiveFor: "affiliate" }));

              pricesMapedPartners.map((item) => delete item.id);
              pricesMapedAffiliate.map((item) => delete item.id);

              setPrices(pricesMaped);
              setPricesPartners(pricesMapedPartners);
              setPricesAffiliate(pricesMapedAffiliate);
            }

            if (arrayPrices.filter((item) => item.exclusiveFor === "website_stripe").length >= 1) {
              const arrayFind = arrayPrices.filter((item) => item.exclusiveFor === "website_stripe");

              arrayFind?.map((item) => {
                pricesMaped.push({
                  id: item.id,
                  value: item.value,
                  utmCpn: item.utmCpn,
                  discount: item.discount,
                  baseValue: item.baseValue,
                  bestSeller: item.bestSeller,
                  exclusiveFor: "website_stripe",
                  priceCountryId: item.priceCountryId,
                  currency: item.priceCountry.standardCurrency,
                });
              });

              setPrices(pricesMaped);
            }

            if (arrayPrices.filter((item) => item.exclusiveFor === "partner").length >= 1) {
              const arrayFind = arrayPrices.filter((item) => item.exclusiveFor === "partner");

              arrayFind?.map((item) => {
                pricesPartners.push({
                  id: item.id,
                  value: item.value,
                  utmCpn: item.utmCpn,
                  exclusiveFor: "partner",
                  discount: item.discount,
                  baseValue: item.baseValue,
                  bestSeller: item.bestSeller,
                  priceCountryId: item.priceCountryId,
                  currency: item.priceCountry.standardCurrency,
                });
              });

              setPricesPartners(pricesPartners);
            }

            if (arrayPrices.filter((item) => item.exclusiveFor === "affiliate").length >= 1) {
              const arrayFind = arrayPrices.filter((item) => item.exclusiveFor === "affiliate");

              arrayFind?.map((item) => {
                pricesAffiliate.push({
                  id: item.id,
                  value: item.value,
                  utmCpn: item.utmCpn,
                  exclusiveFor: "affiliate",
                  discount: item.discount,
                  baseValue: item.baseValue,
                  bestSeller: item.bestSeller,
                  priceCountryId: item.priceCountryId,
                  currency: item.priceCountry.standardCurrency,
                });
              });

              setPricesAffiliate(pricesAffiliate);
            }
          }

          setNameEnglish(res[0].plan.nameEnglish);
          setNameSpanish(res[0].plan.nameSpanish);
          setNameFrench(res[0].plan.nameFrench);
          setNamePortuguese(res[0].plan.namePortuguese);
          setDescriptionEnglish(res[0].plan.descriptionEnglish);
          setDescriptionSpanish(res[0].plan.descriptionSpanish);
          setDescriptionFrench(res[0].plan.descriptionFrench);
          setDescriptionPortuguese(res[0].plan.descriptionPortuguese);
          setTotalClasses(res[0].plan.totalClasses);
          setUnlimited(res[0].plan.unlimited);
          setTrial(res[0].plan.trial);
          setMultiLingo(res[0].multiLingo);
          setActive(res[0].plan.active);
          setActiveWeb(res[0].plan.activeWeb);
          setProvider(res[0].plan.provider);
          setPaymentLink(res[0].plan.payment_link);

          let arrplanLanguages = [];

          res.map((item) => {
            if (item.lingoLanguage !== null) {
              arrplanLanguages.push(item.lingoLanguage.id);
            }
          });

          setPlanLanguages(arrplanLanguages);
        })
        .catch((err) => {
          let errMsg =
            err?.response?.data?.error?.message !== undefined ? err?.response?.data?.error?.message : err.toString();

          setDialogTitle("Ops!");
          setDialogMsg(errMsg);
          setOpen(true);
          setIsDelete(false);
        });
    } else {
      dispatch(getCountriesPrices()).then((res) => setCountries(res));
    }
  };

  useEffect(() => {
    loadInfos();
    // eslint-disable-next-line
  }, []);

  const addField = (e) => {
    e.preventDefault();
    if (e.target.name === "addLingo") {
      setPlanLanguages([...planLanguages, 0]);
    }

    if (e.target.name === "addCountry") {
      setPrices([
        ...prices,
        {
          priceCountryId: 0,
          currency: "",
          value: 0,
          utmCpn: "",
          baseValue: 0,
          discount: 0,
          bestSeller: false,
          exclusiveFor: "website_stripe",
        },
      ]);
      setPricesPartners([
        ...pricesPartners,
        {
          priceCountryId: 0,
          currency: "",
          value: 0,
          utmCpn: "",
          baseValue: 0,
          discount: 0,
          bestSeller: false,
          exclusiveFor: "partner",
        },
      ]);
      setPricesAffiliate([
        ...pricesAffiliate,
        {
          priceCountryId: 0,
          currency: "",
          value: 0,
          utmCpn: "",
          baseValue: 0,
          discount: 0,
          bestSeller: false,
          exclusiveFor: "affiliate",
        },
      ]);
    }
  };

  const removeLingo = (e, findIndex) => {
    setPlanLanguages(planLanguages.filter((value, index) => index !== findIndex));
  };

  const removePrice = (e, findIndex) => {
    e.preventDefault();

    let targetArrIndex = e.target.id;

    if (prices[targetArrIndex].id !== undefined) {
      if (prices.length > 1) {
        dispatch(deletePrices(prices[targetArrIndex].id)).then(() =>
          setPrices(prices.filter((value, index) => index !== targetArrIndex)),
        );

        dispatch(deletePrices(pricesPartners[targetArrIndex].id)).then(() =>
          setPricesPartners(pricesPartners.filter((value, index) => index !== targetArrIndex)),
        );

        dispatch(deletePrices(pricesAffiliate[targetArrIndex].id)).then(() =>
          setPricesAffiliate(pricesAffiliate.filter((value, index) => index !== targetArrIndex)),
        );
      } else {
        setPrices(prices.filter((value, index) => index !== findIndex));
        setPricesPartners(pricesPartners.filter((value, index) => index !== findIndex));
        setPricesAffiliate(pricesAffiliate.filter((value, index) => index !== findIndex));
      }
    } else {
      setPrices(prices.filter((value, index) => index !== findIndex));
      setPricesPartners(pricesPartners.filter((value, index) => index !== findIndex));
      setPricesAffiliate(pricesAffiliate.filter((value, index) => index !== findIndex));
    }
  };

  const handlerChangeList = (e, index) => {
    const { name, value, id } = e.target;

    if (name === "planLanguage") {
      setPlanLanguages((state) => state.map((item, i) => (i === index ? value : item)));
    } else {
      if (name === "discount") {
        setPrices((state) =>
          state.map((item, i) =>
            i === index
              ? {
                  ...item,
                  discount: value,
                  value: Math.ceil(((prices[id]?.baseValue - value) * 100) / prices[id]?.baseValue),
                }
              : item,
          ),
        );
      } else {
        if (name === "value") {
          setPrices((state) => state.map((item, i) => (i === index ? { ...item, value: value } : item)));
        } else if (name === "baseValue") {
          setPrices((state) => state.map((item, i) => (i === index ? { ...item, baseValue: value } : item)));
        } else if (name === "priceCountryId") {
          setPrices((state) => state.map((item, i) => (i === index ? { ...item, priceCountryId: value } : item)));
        } else if (name === "utmCpn") {
          setPrices((state) => state.map((item, i) => (i === index ? { ...item, utmCpn: value } : item)));
        } else if (name === "bestSeller") {
          setPrices((state) => state.map((item, i) => (i === index ? { ...item, bestSeller: value } : item)));
        }
      }
    }
  };

  const handlerChangeListPartners = (e, index) => {
    const { name, value, id } = e.target;

    if (name === "discount") {
      setPricesPartners((state) =>
        state.map((item, i) =>
          i === index
            ? {
                ...item,
                discount: value,
                value: Math.ceil(((pricesPartners[id]?.baseValue - value) * 100) / pricesPartners[id]?.baseValue),
              }
            : item,
        ),
      );
    } else {
      if (name === "value") {
        setPricesPartners((state) => state.map((item, i) => (i === index ? { ...item, value: value } : item)));
      } else if (name === "baseValue") {
        setPricesPartners((state) => state.map((item, i) => (i === index ? { ...item, baseValue: value } : item)));
      } else if (name === "priceCountryId") {
        setPricesPartners((state) => state.map((item, i) => (i === index ? { ...item, priceCountryId: value } : item)));
      } else if (name === "utmCpn") {
        setPricesPartners((state) => state.map((item, i) => (i === index ? { ...item, utmCpn: value } : item)));
      } else if (name === "bestSeller") {
        setPricesPartners((state) => state.map((item, i) => (i === index ? { ...item, bestSeller: value } : item)));
      }
    }
  };

  const handlerChangeListAffiliate = (e, index) => {
    const { name, value, id } = e.target;

    if (name === "discount") {
      setPricesAffiliate((state) =>
        state.map((item, i) =>
          i === index
            ? {
                ...item,
                discount: value,
                value: Math.ceil(((pricesAffiliate[id]?.baseValue - value) * 100) / pricesAffiliate[id]?.baseValue),
              }
            : item,
        ),
      );
    } else {
      if (name === "value") {
        setPricesAffiliate((state) => state.map((item, i) => (i === index ? { ...item, value: value } : item)));
      } else if (name === "baseValue") {
        setPricesAffiliate((state) => state.map((item, i) => (i === index ? { ...item, baseValue: value } : item)));
      } else if (name === "priceCountryId") {
        setPricesAffiliate((state) =>
          state.map((item, i) => (i === index ? { ...item, priceCountryId: value } : item)),
        );
      } else if (name === "utmCpn") {
        setPricesAffiliate((state) => state.map((item, i) => (i === index ? { ...item, utmCpn: value } : item)));
      } else if (name === "bestSeller") {
        setPricesAffiliate((state) => state.map((item, i) => (i === index ? { ...item, bestSeller: value } : item)));
      }
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    switch (name) {
      case "nameEnglish":
        setNameEnglish(value);
        break;
      case "namePortuguese":
        setNamePortuguese(value);
        break;
      case "nameSpanish":
        setNameSpanish(value);
        break;
      case "nameFrench":
        setNameFrench(value);
        break;
      case "descriptionEnglish":
        setDescriptionEnglish(value);
        break;
      case "descriptionPortuguese":
        setDescriptionPortuguese(value);
        break;
      case "descriptionSpanish":
        setDescriptionSpanish(value);
        break;
      case "descriptionFrench":
        setDescriptionFrench(value);
        break;
      case "totalClasses":
        setTotalClasses(value);
        break;
      case "paymentLink":
        setPaymentLink(value);
        break;

      default:
        break;
    }
  };

  const handleInputChange = (e) => {
    const target = e.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    if (name === "active") {
      setActive(value);
    }

    if (name === "multiLingo") {
      setMultiLingo(value);
    }

    if (name === "trial") {
      setTrial(value);
    }

    if (name === "unlimited") {
      setUnlimited(value);
    }
    if (name === "activeWeb") {
      setActiveWeb(value);
    }

    if (name === "provider") {
      setProvider(value);
    }
  };

  const handlePost = () => {
    if (!multiLingo && planLanguages.length === 0) {
      setDialogTitle("Ops!");
      setDialogMsg("At least one plan language or multilingo was required!");
      setOpen(true);
      setIsDelete(false);
      return;
    }

    if (prices.length === 0) {
      setDialogTitle("Ops!");
      setDialogMsg("At least one country price was required!");
      setOpen(true);
      setIsDelete(false);
      return;
    }
    if (provider === null) {
      setDialogTitle("Ops!");
      setDialogMsg("The provider field is mandatory");
      setOpen(true);
      setIsDelete(false);
      return;
    }

    let newPrices = prices.concat(pricesPartners, pricesAffiliate).filter((item) => item.priceCountryId !== 0);

    let sendObj = {
      plan: {
        nameFrench: nameFrench,
        nameEnglish: nameEnglish,
        nameSpanish: nameSpanish,
        namePortuguese: namePortuguese,
        descriptionEnglish: descriptionEnglish,
        descriptionSpanish: descriptionSpanish,
        descriptionFrench: descriptionFrench,
        descriptionPortuguese: descriptionPortuguese,
        totalClasses: Number(totalClasses),
        unlimited: unlimited,
        active: active,
        multiLingo: multiLingo,
        provider: provider,
        activeWeb: activeWeb,
        trial: trial,
        payment_link: paymentLink,
      },
      prices: newPrices,
      planLanguages: multiLingo ? [] : planLanguages,
    };
    sendObj.prices.map((item) => {
      item.baseValue = String(item.baseValue);
      item.discount = String(item.discount);
      item.value = String(item.value);
    });

    if (id !== undefined) {
      sendObj.plan.id = Number(id);
    }

    try {
      dispatch(postPlanPrices(JSON.stringify(sendObj)))
        .then((resp) => resp.success && setRedirect(true))
        .catch((err) => {
          let errMsg = err?.response?.data?.error.length
            ? err?.response?.data?.error[0]?.message
            : err?.response?.data?.error;

          setOpen(true);
          setIsDelete(false);
          setDialogTitle("Ops!");
          setDialogMsg(errMsg);
        });
    } catch (err) {
      console.error(err);
    }
  };

  const handleDelete = () => {
    setOpen(false);
    dispatch(deletePlanPrices(id))
      .then(() => {
        setRedirect(true);
      })
      .catch((err) => {
        let errMsg =
          err.response.data.error.errors[0].message !== undefined
            ? err.response.data.error.errors[0].message
            : err.data.errors[0].message;

        setDialogTitle("Ops!");
        setDialogMsg(errMsg);
        setOpen(true);
        setIsDelete(false);
      });
  };

  if (redirect) {
    return <Navigate to="/plans-and-prices" />;
  }

  return (
    <div className="view">
      <SideMenu />

      <section>
        <Header t={t} title="Plans and Prices" icon={<img src={Engrenagem} alt="Engrenagem" />} typeIcon="custom" />

        <Prices>
          <div className="content">
            <div className="bigBox teste">
              <h2>{!id ? "Add New Plan" : nameEnglish}</h2>

              <div className="planInfo">
                <h3>Plan Information</h3>

                <form className="formulario">
                  <div>
                    <label htmlFor="name">{t("ENGLISH")}</label>
                    <span>{t("REQUIRED")}</span>
                  </div>
                  <input placeholder="Enter name" name="nameEnglish" value={nameEnglish} onChange={handleChange} />

                  <div>
                    <label htmlFor="name">{t("PORTUGUESE")}</label>
                    <span>{t("REQUIRED")}</span>
                  </div>
                  <input
                    placeholder="Enter name"
                    name="namePortuguese"
                    value={namePortuguese}
                    onChange={handleChange}
                  />

                  <div>
                    <label htmlFor="name">{t("SPANISH")}</label>
                    <span>{t("REQUIRED")}</span>
                  </div>
                  <input placeholder="Enter name" name="nameSpanish" value={nameSpanish} onChange={handleChange} />

                  <div>
                    <label htmlFor="name">{t("FRENCH")}</label>
                    <span>{t("REQUIRED")}</span>
                  </div>
                  <input placeholder="Enter name" name="nameFrench" value={nameFrench} onChange={handleChange} />

                  <h4>{t("DESCRIPTION")}</h4>

                  <div>
                    <label htmlFor="name">{t("ENGLISH")}</label>
                    <span>{t("REQUIRED")}</span>
                  </div>
                  <input
                    placeholder="Description of the language"
                    name="descriptionEnglish"
                    value={descriptionEnglish}
                    onChange={handleChange}
                  />

                  <div>
                    <label htmlFor="name">{t("PORTUGUESE")}</label>
                    <span>{t("REQUIRED")}</span>
                  </div>
                  <input
                    placeholder="Description of the language"
                    name="descriptionPortuguese"
                    value={descriptionPortuguese}
                    onChange={handleChange}
                  />

                  <div>
                    <label htmlFor="name">{t("SPANISH")}</label>
                    <span>{t("REQUIRED")}</span>
                  </div>
                  <input
                    placeholder="Description of the language"
                    name="descriptionSpanish"
                    value={descriptionSpanish}
                    onChange={handleChange}
                  />

                  <div>
                    <label htmlFor="name">{t("FRENCH")}</label>
                    <span>{t("REQUIRED")}</span>
                  </div>
                  <input
                    placeholder="Description of the language"
                    name="descriptionFrench"
                    value={descriptionFrench}
                    onChange={handleChange}
                  />

                  <div className="wrapperRow">
                    <div>
                      <label htmlFor="switch-shadow">Unlimited classes?</label>
                      <div className="switchBox">
                        <div className="switch__container addInput">
                          <input
                            id="switch-shadow"
                            className="switch switch--shadow"
                            name="unlimited"
                            type="checkbox"
                            checked={unlimited}
                            onChange={handleInputChange}
                          />
                          <label htmlFor="switch-shadow">
                            <span>{unlimited ? "Yes" : "No"}</span>
                          </label>
                        </div>
                      </div>
                    </div>

                    <div className="numberClass" style={{ display: unlimited ? "none" : "" }}>
                      <div>
                        <label htmlFor="gender">{t("BTN_NUMBER_CLASSES")}</label>
                        <span>{t("REQUIRED")}</span>
                      </div>
                      <input
                        type="text"
                        placeholder="Number of classes"
                        name="totalClasses"
                        value={totalClasses}
                        onChange={handleChange}
                        className="inputMobile"
                      />
                    </div>
                  </div>

                  <label htmlFor="switch-shadow5">Multi language?</label>
                  <div className="switchBox">
                    <div className="switch__container addInput">
                      <input
                        id="switch-shadow5"
                        className="switch switch--shadow"
                        name="multiLingo"
                        type="checkbox"
                        checked={multiLingo}
                        onChange={handleInputChange}
                      />
                      <label htmlFor="switch-shadow5">
                        <span>{multiLingo ? "Yes" : "No"}</span>
                      </label>
                    </div>
                  </div>

                  <label htmlFor="switch-shadow5">Trial ?</label>
                  <div className="switchBox">
                    <div className="switch__container addInput">
                      <input
                        id="switch-shadow6"
                        className="switch switch--shadow"
                        name="trial"
                        type="checkbox"
                        checked={trial}
                        onChange={handleInputChange}
                      />
                      <label htmlFor="switch-shadow6">
                        <span>{trial ? "Yes" : "No"}</span>
                      </label>
                    </div>
                  </div>
                </form>

                <div className="lingos" style={{ display: multiLingo ? "none" : "" }}>
                  <h4>Lingos</h4>

                  <div className="lingoSelects">
                    <div className="linha" />
                    <div className="selects">
                      <div className="delet">
                        <div className="inputDelete">
                          {planLanguages.map((item, index) => (
                            <div key={index}>
                              <Select
                                value={item}
                                onChange={(event) => {
                                  let objTarget = {
                                    target: {
                                      id: index,
                                      name: event.target.name,
                                      value: event.target.value,
                                    },
                                  };
                                  handlerChangeList(objTarget, index);
                                }}
                                inputProps={{
                                  id: index.toString(),
                                  name: "planLanguage",
                                }}
                                className="input-lingo"
                                disableUnderline
                              >
                                {allLingos.map((item) => {
                                  return (
                                    <MenuItem key={item.id} value={item.id}>
                                      <div style={{ display: "flex", alignItems: "center" }}>
                                        <FlagIcon code={item.flag} /> &nbsp;{item.language.name}
                                      </div>
                                    </MenuItem>
                                  );
                                })}
                              </Select>
                              <SCButtonAddInput
                                ml="12px"
                                id={index}
                                name="remove"
                                onClick={(e) => removeLingo(e, index)}
                              >
                                Delete <i className="fa fa-times-circle-o" aria-hidden="true" />
                              </SCButtonAddInput>
                            </div>
                          ))}
                        </div>
                        <SCButtonAddInput name="addLingo" onClick={(e) => addField(e)}>
                          Add lingo +
                        </SCButtonAddInput>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="lingos">
                  <div className="price">
                    <h4>Price</h4>

                    <div className="lingoSelects">
                      <div className="selects">
                        <div className="delet">
                          {prices.map((item, index) => (
                            <div key={index} className="wrapperPrice">
                              <div className="lineContent">
                                <div className="linhaPrice" />

                                <div>
                                  <p className="title">Web</p>
                                  <label htmlFor="country">Country</label>
                                  <div className="countryCurrency">
                                    <select
                                      value={item.priceCountryId}
                                      id={index.toString()}
                                      name={"priceCountryId"}
                                      onChange={(event) => {
                                        let objTarget = {
                                          target: {
                                            id: index,
                                            name: event.target.name,
                                            value: Number(event.target.value),
                                          },
                                        };
                                        handlerChangeList(objTarget, index);
                                      }}
                                      className="input-lingo"
                                    >
                                      <option>Select</option>
                                      {countries.map((countrie) => (
                                        <option key={countrie.id} value={countrie.id}>
                                          {countrie.country.name}
                                        </option>
                                      ))}
                                    </select>
                                    <span className="currency">Currency: {item?.currency}</span>
                                  </div>
                                  <form className="formulario">
                                    <div>
                                      <label htmlFor="name">Base Price</label>
                                      <span>{t("REQUIRED")}</span>
                                    </div>
                                    <input
                                      id={index}
                                      placeholder="Base price"
                                      name="baseValue"
                                      type="number"
                                      value={item.baseValue}
                                      onChange={(e) => handlerChangeList(e, index)}
                                      required
                                    />
                                    <div>
                                      <label htmlFor="discount">Final Price</label>
                                      <span>{t("REQUIRED")}</span>
                                    </div>
                                    <input
                                      id={index}
                                      placeholder="Discount price"
                                      name="discount"
                                      type="number"
                                      value={item.discount}
                                      onChange={(e) => handlerChangeList(e, index)}
                                      className="inputMobile"
                                      required
                                    />
                                    <div>
                                      <label htmlFor="value">Discount Rate</label>
                                      <span>{t("REQUIRED")}</span>
                                    </div>
                                    <input
                                      id={index}
                                      placeholder="Discount rate"
                                      name="value"
                                      type="number"
                                      value={item.value}
                                      onChange={(e) => handlerChangeList(e, index)}
                                      className="inputMobile"
                                      required
                                    />
                                    <div>
                                      <label htmlFor="value">UtmCpn</label>
                                      <span>{t("REQUIRED")}</span>
                                    </div>
                                    <input
                                      required
                                      id={index}
                                      type="text"
                                      name="utmCpn"
                                      value={item.utmCpn}
                                      placeholder="UtmCpn"
                                      className="inputMobile"
                                      onChange={(e) => handlerChangeList(e, index)}
                                    />
                                    <label htmlFor="gender">Best Seller?</label>
                                    <div className="switchBox">
                                      <div className="switch__container">
                                        <input
                                          key={index}
                                          id={"switch-shadow" + (1 + index + "web")}
                                          className="switch switch--shadow"
                                          name="bestSeller"
                                          type="checkbox"
                                          checked={item.bestSeller}
                                          onChange={(event) => {
                                            let objTargetSwitch = {
                                              target: {
                                                id: index,
                                                name: event.target.name,
                                                value: !item.bestSeller,
                                              },
                                            };
                                            handlerChangeList(objTargetSwitch, index);
                                          }}
                                        />
                                        <label htmlFor={"switch-shadow" + (1 + index + "web")}>
                                          <span className="bestSeller">{item.bestSeller ? "Yes" : "No"}</span>
                                        </label>
                                      </div>
                                    </div>
                                    {prices.length > 0 && (
                                      <SCButtonAddInput id={index} name="remove" onClick={(e) => removePrice(e, index)}>
                                        Delete <i className="fa fa-times-circle-o" aria-hidden="true" />
                                      </SCButtonAddInput>
                                    )}
                                  </form>
                                </div>

                                <div>
                                  <p className="title">Partners</p>
                                  <label htmlFor="country">Country</label>
                                  <div className="countryCurrency">
                                    <select
                                      id={index.toString()}
                                      name={"priceCountryId"}
                                      className="input-lingo"
                                      value={pricesPartners[index]?.priceCountryId}
                                      onChange={(event) => {
                                        let objTarget = {
                                          target: {
                                            id: index,
                                            name: event.target.name,
                                            value: Number(event.target.value),
                                          },
                                        };
                                        handlerChangeListPartners(objTarget, index);
                                      }}
                                    >
                                      <option>{t("SELECT")}</option>
                                      {countries.map((countrie) => (
                                        <option key={countrie.id} value={countrie.id}>
                                          {countrie.country.name}
                                        </option>
                                      ))}
                                    </select>
                                    <span className="currency">Currency: {item?.currency}</span>
                                  </div>
                                  <form className="formulario">
                                    <div>
                                      <label htmlFor="name">Base Price</label>
                                      <span>{t("REQUIRED")}</span>
                                    </div>
                                    <input
                                      required
                                      id={index}
                                      type="number"
                                      name="baseValue"
                                      placeholder="Base price"
                                      value={pricesPartners[index]?.baseValue}
                                      onChange={(e) => handlerChangeListPartners(e, index)}
                                    />
                                    <div>
                                      <label htmlFor="discount">Final Price</label>
                                      <span>{t("REQUIRED")}</span>
                                    </div>
                                    <input
                                      required
                                      id={index}
                                      type="number"
                                      name="discount"
                                      className="inputMobile"
                                      placeholder="Discount price"
                                      value={pricesPartners[index]?.discount}
                                      onChange={(e) => handlerChangeListPartners(e, index)}
                                    />
                                    <div>
                                      <label htmlFor="value">Discount Rate</label>
                                      <span>{t("REQUIRED")}</span>
                                    </div>
                                    <input
                                      required
                                      id={index}
                                      name="value"
                                      type="number"
                                      className="inputMobile"
                                      placeholder="Discount rate"
                                      value={pricesPartners[index]?.value}
                                      onChange={(e) => handlerChangeListPartners(e, index)}
                                    />
                                    <div>
                                      <label htmlFor="value">UtmCpn</label>
                                      <span>{t("REQUIRED")}</span>
                                    </div>
                                    <input
                                      required
                                      id={index}
                                      type="text"
                                      name="utmCpn"
                                      placeholder="UtmCpn"
                                      className="inputMobile"
                                      value={pricesPartners[index]?.utmCpn}
                                      onChange={(e) => handlerChangeListPartners(e, index)}
                                    />
                                    <label htmlFor="gender">Best Seller?</label>
                                    <div className="switchBox">
                                      <div className="switch__container">
                                        <input
                                          key={index}
                                          id={"switch-shadow" + (2 + index + "partner")}
                                          className="switch switch--shadow"
                                          name="bestSeller"
                                          type="checkbox"
                                          checked={pricesPartners[index]?.bestSeller}
                                          onChange={(event) => {
                                            let objTargetSwitch = {
                                              target: {
                                                id: index,
                                                name: event.target.name,
                                                value: !pricesPartners[index]?.bestSeller,
                                              },
                                            };
                                            handlerChangeListPartners(objTargetSwitch, index);
                                          }}
                                        />
                                        <label htmlFor={"switch-shadow" + (2 + index + "partner")}>
                                          <span className="bestSeller">
                                            {pricesPartners[index]?.bestSeller ? "Yes" : "No"}
                                          </span>
                                        </label>
                                      </div>
                                    </div>
                                  </form>
                                </div>

                                <div>
                                  <p className="title">{t("AFFILIATE")}</p>
                                  <label htmlFor="country">Country</label>
                                  <div className="countryCurrency">
                                    <select
                                      id={index.toString()}
                                      className="input-lingo"
                                      name={"priceCountryId"}
                                      value={pricesAffiliate[index]?.priceCountryId}
                                      onChange={(event) => {
                                        let objTarget = {
                                          target: {
                                            id: index,
                                            name: event.target.name,
                                            value: Number(event.target.value),
                                          },
                                        };
                                        handlerChangeListAffiliate(objTarget, index);
                                      }}
                                    >
                                      <option>{t("SELECT")}</option>
                                      {countries.map((countrie) => (
                                        <option key={countrie.id} value={countrie.id}>
                                          {countrie.country.name}
                                        </option>
                                      ))}
                                    </select>
                                    <span className="currency">Currency: {item?.currency}</span>
                                  </div>
                                  <form className="formulario">
                                    <div>
                                      <label htmlFor="name">Base Price</label>
                                      <span>{t("REQUIRED")}</span>
                                    </div>
                                    <input
                                      required
                                      id={index}
                                      type="number"
                                      name="baseValue"
                                      placeholder="Base price"
                                      value={pricesAffiliate[index]?.baseValue}
                                      onChange={(e) => handlerChangeListAffiliate(e, index)}
                                    />
                                    <div>
                                      <label htmlFor="discount">Final Price</label>
                                      <span>{t("REQUIRED")}</span>
                                    </div>
                                    <input
                                      required
                                      id={index}
                                      type="number"
                                      name="discount"
                                      className="inputMobile"
                                      placeholder="Discount price"
                                      value={pricesAffiliate[index]?.discount}
                                      onChange={(e) => handlerChangeListAffiliate(e, index)}
                                    />
                                    <div>
                                      <label htmlFor="value">Discount Rate</label>
                                      <span>{t("REQUIRED")}</span>
                                    </div>
                                    <input
                                      required
                                      id={index}
                                      name="value"
                                      type="number"
                                      className="inputMobile"
                                      placeholder="Discount rate"
                                      value={pricesAffiliate[index]?.value}
                                      onChange={(e) => handlerChangeListAffiliate(e, index)}
                                    />
                                    <div>
                                      <label htmlFor="value">UtmCpn</label>
                                      <span>{t("REQUIRED")}</span>
                                    </div>
                                    <input
                                      required
                                      id={index}
                                      type="text"
                                      name="utmCpn"
                                      placeholder="UtmCpn"
                                      className="inputMobile"
                                      value={pricesAffiliate[index]?.utmCpn}
                                      onChange={(e) => handlerChangeListAffiliate(e, index)}
                                    />
                                    <label htmlFor="gender">Best Seller?</label>
                                    <div className="switchBox">
                                      <div className="switch__container">
                                        <input
                                          key={index}
                                          id={"switch-shadow" + (3 + index + "affiliate")}
                                          className="switch switch--shadow"
                                          name="bestSeller"
                                          type="checkbox"
                                          checked={pricesAffiliate[index]?.bestSeller}
                                          onChange={(event) => {
                                            let objTargetSwitch = {
                                              target: {
                                                id: index,
                                                name: event.target.name,
                                                value: !pricesAffiliate[index]?.bestSeller,
                                              },
                                            };
                                            handlerChangeListAffiliate(objTargetSwitch, index);
                                          }}
                                        />
                                        <label htmlFor={"switch-shadow" + (3 + index + "affiliate")}>
                                          <span className="bestSeller">
                                            {pricesAffiliate[index]?.bestSeller ? "Yes" : "No"}
                                          </span>
                                        </label>
                                      </div>
                                    </div>
                                  </form>
                                </div>
                              </div>
                            </div>
                          ))}

                          <SCButtonAddInput mWidth="155px" name="addCountry" mb="12px" onClick={(e) => addField(e)}>
                            Add Price +
                          </SCButtonAddInput>

                          <div className="wrapperRow">
                            <div>
                              <label>Status</label>
                              <div className="switchBox">
                                <div className="switch__container addInput">
                                  <input
                                    id="switch-shadow4"
                                    className="switch switch--shadow"
                                    name="active"
                                    type="checkbox"
                                    checked={active}
                                    onChange={handleInputChange}
                                  />
                                  <label htmlFor="switch-shadow4">
                                    <span>{active ? "Yes" : "No"}</span>
                                  </label>
                                </div>
                              </div>
                            </div>

                            <div>
                              <label>Web</label>
                              <div className="switchBox">
                                <div className="switch__container addInput">
                                  <input
                                    type="checkbox"
                                    name="activeWeb"
                                    id="switch-shadow3"
                                    checked={activeWeb}
                                    className="switch switch--shadow"
                                    onChange={handleInputChange}
                                  />
                                  <label htmlFor="switch-shadow3">
                                    <span>{activeWeb ? "Yes" : "No"}</span>
                                  </label>
                                </div>
                              </div>
                            </div>

                            <div>
                              <label>{t("PROVIDER")}</label>
                              <div style={{ marginTop: 5 }}>
                                <select
                                  name="provider"
                                  value={provider}
                                  className="input-lingo"
                                  onChange={handleInputChange}
                                >
                                  <option value="">{t("SELECT")}</option>
                                  <option value="stripe">Stripe</option>
                                  <option value="stripeBR">Stripe BR</option>
                                  <option value="b2b">B2B</option>
                                </select>
                              </div>
                            </div>
                          </div>

                          {id && (
                            <button
                              onClick={() => {
                                setIsDelete(true), setOpen(true);
                              }}
                              className="deletePlans"
                            >
                              Delete Plan
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="lingos ">
                  <div className="price">
                    <h4>Payment link</h4>
                  </div>

                  <form className="formulario">
                    {/* <div>
                      <label htmlFor="name">English</label>
                      <span>{t("REQUIRED")}</span>
                    </div> */}
                    <input
                      name="paymentLink"
                      value={paymentLink}
                      onChange={handleChange}
                      placeholder="Enter payment link"
                    />
                  </form>
                </div>
              </div>
            </div>
            <div className="buttons">
              <Link to="/plans-and-prices">
                <button>
                  <i className="fa fa-angle-left" aria-hidden="true"></i>Back
                </button>
              </Link>
              <button onClick={handlePost}>Save</button>
            </div>
          </div>

          <Dialog
            open={open}
            TransitionComponent={Transition}
            keepMounted
            onClose={() => setOpen(false)}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
            className="boxModal"
          >
            <DialogTitle id="alert-dialog-slide-title" className="boxModal title">
              {dialogTitle}
            </DialogTitle>
            <DialogContent className="boxModal">
              <DialogContentText id="alert-dialog-slide-description" className="boxModal">
                {isDelete ? "Do you really want to delete" + nameEnglish : dialogMsg}
              </DialogContentText>
            </DialogContent>
            <DialogActions className="boxModal">
              {isDelete && (
                <Button onClick={handleDelete} color="primary">
                  {"Yes, delete"}
                </Button>
              )}
              <Button onClick={() => setOpen(false)} color="primary">
                {"Cancel"}
              </Button>
            </DialogActions>
          </Dialog>
        </Prices>
      </section>
    </div>
  );
}

export default PlansAndPrices;
